import {
  SET_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK,
  GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK,
  SET_SEARCH_PARAMS_RECORD_TRAINED_USERS,
  GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS,
  GET_DATA_PAGINATION_RECORD_TRAINED_USERS_LOGBOOK,
} from "../types";

const initialState = {
  data: [],
  searchParams: {
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    trainingOrgsName: "",
    trainingProgId: 0,
    trainingDocumentsDateStart: "",
    trainingDocumentsDateEnd: "",
  },
  dataRecordLogbook: [],
  dataPaginationRecordLogbook: [],
  searchParamsRecordLogbook: {
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    trainingOrgsId: 0,
    trainingProgId: 0,
    trainingDocumentsDateStart: "",
    trainingDocumentsDateEnd: "",
  },
};

export const recordTrainedUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK:
      return {
        ...state,
        searchParamsRecordLogbook: Object.assign(
          state.searchParamsRecordLogbook,
          action.data,
        ),
      };
    case GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS_LOGBOOK: {
      return {
        ...state,
        dataRecordLogbook: [...action.data],
      };
    }
    case GET_DATA_PAGINATION_RECORD_TRAINED_USERS_LOGBOOK: {
      return {
        ...state,
        dataPaginationRecordLogbook: action.data,
      };
    }
    case SET_SEARCH_PARAMS_RECORD_TRAINED_USERS:
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    case GET_DATA_BY_SEARCH_PARAMS_RECORD_TRAINED_USERS: {
      return {
        ...state,
        data: action.data,
      };
    }
    default:
      return state;
  }
};
